import If from 'global/Common/If';

import { useCustomEvent } from 'hooks/useCustomEvent';
import useDatafeedModalStore, { ModalNames } from './datafeed-modal.store';
import AraArbEstimsationModal from './ModalAraArbEstimation';
import { AutoRejectEstimation } from '../../../../@types/orderbook';

interface AraArbEstimationDetail {
  symbol: string;
  data: AutoRejectEstimation[];
}

export default function StreamErrorModalManager() {
  const modal = useDatafeedModalStore((s) => s.activeModal);
  const openModal = useDatafeedModalStore((s) => s.openModal);
  const closeModal = useDatafeedModalStore((s) => s.closeModal);

  useCustomEvent<AraArbEstimationDetail>({
    eventName: 'ara-estimation-modal/open',
    onSignal: ({ detail }) => {
      const { symbol, data } = detail;

      if (!symbol || !data) return;

      openModal(ModalNames.ARA_ARB_ESTIMATION, {
        symbol,
        data,
      });
    },
  });

  if (!modal) {
    return null;
  }

  return (
    <If condition={modal === ModalNames.ARA_ARB_ESTIMATION}>
      <AraArbEstimsationModal
        isOpen={modal === ModalNames.ARA_ARB_ESTIMATION}
        onClose={closeModal}
      />
    </If>
  );
}
